var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page",class:_vm.pageClass},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }